// Vollständigkeit einer hochgeladenen Version (Audit 2026-09-24, M15).
//
// Der Server legt den Versions-Record schon beim Reservieren der Nummer an
// (`status: 'pending'`) und schaltet ihn erst auf `complete`, wenn alle
// angekündigten Dateien in der Cloud liegen — auch die, die nach dem Bundle
// über den Chunk-Upload nachkommen (Video, lange WAVs). Bricht ein Upload
// dazwischen ab (Tab zu, Crash, Cancel-DELETE gescheitert), bleibt ein
// pending-Record zurück: Die UI zeigt ihn als „unvollständig“ statt als
// „Uploaded“, zählt ihn nirgends als Lieferung und bietet Aufräumen an.
//
// Records ohne `status` stammen aus der Zeit davor und gelten als complete.

export interface VersionLike {
  version: number;
  status?: 'pending' | 'complete';
  files?: string[];
  expectedFiles?: string[];
}

export const isVersionComplete = (v: VersionLike): boolean => v.status !== 'pending';

export const isVersionPending = (v: VersionLike): boolean => v.status === 'pending';

/** Nur die vollständigen Versionen — Basis für „Uploaded“, Leave-Guard, Summary. */
export function completeVersions<T extends VersionLike>(list: ReadonlyArray<T> | undefined): T[] {
  return (list ?? []).filter(isVersionComplete);
}

export function pendingVersions<T extends VersionLike>(list: ReadonlyArray<T> | undefined): T[] {
  return (list ?? []).filter(isVersionPending);
}

/** Angekündigte, aber noch nicht abgelegte Dateien einer Version (für Hinweise). */
export function missingFiles(v: VersionLike): string[] {
  const have = new Set(v.files ?? []);
  return (v.expectedFiles ?? []).filter((f) => !have.has(f));
}
